import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

export type SetImpersonationAccessRequestDto = {
  id: number;
  canImpersonate: boolean;
};
export type SetImpersonationAccessResponseDto = z.infer<typeof UserDtoSchema>;

// Super-admin only — grants or revokes a user's LIAC (Log In As Customer) access.
export const setImpersonationAccess = (
  { id, canImpersonate }: SetImpersonationAccessRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .patch(`/users/${id}/impersonation-access`, { canImpersonate }, config)
    .then(responseContract(UserDtoSchema));
};
